export default {"src":"/_next/static/media/menu.de15c9ca.svg","height":20,"width":20};